import { Quill } from 'react-quill';

// Custom Blot 정의
const BlockEmbed = Quill.import('blots/block/embed');

class customHr extends BlockEmbed {
  static create(value) {
    const node = super.create() as HTMLElement;
    node.setAttribute('contenteditable', 'false');
    node.classList.add('custom-hr-block');

    if (value?.style) {
      node.setAttribute('data-ke-style', value.style);
    }

    // 클릭 이벤트 추가
    node.addEventListener('click', (e) => {
      e.stopPropagation(); // 이벤트 버블링 방지
      customHr.clearSelectedHr(); // 기존 선택된 <hr> 초기화
      node.classList.add('hr-selected'); // 선택 스타일 추가
    });

    return node;
  }

  format(name: string, value: string) {
    if (name === 'data-ke-style' && value) {
      this.domNode.setAttribute('data-ke-style', value); // 속성 설정
    } else {
      this.domNode.removeAttribute('data-ke-style');
    }
  }

  static clearSelectedHr() {
    // 선택된 <hr> 초기화
    const selectedHrs = document.querySelectorAll('.hr-selected');
    selectedHrs.forEach((hr) => hr.classList.remove('hr-selected'));
  }
}

customHr.blotName = 'hr';
customHr.tagName = 'hr';

export default customHr;
